import {
  Blocks,
  BotMessageSquare,
  CodeXml,
  DollarSign,
  MousePointerClick
} from "lucide-react"
import { IntegrationType } from "../../../../../types"

const STROKE_COLOR = "#232227"

const LoanOfficerEmbedIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6666 1.66602H4.99992C4.55789 1.66602 4.13397 1.84161 3.82141 2.15417C3.50885 2.46673 3.33325 2.89065 3.33325 3.33268V16.666C3.33325 17.108 3.50885 17.532 3.82141 17.8445C4.13397 18.1571 4.55789 18.3327 4.99992 18.3327H14.9999C15.4419 18.3327 15.8659 18.1571 16.1784 17.8445C16.491 17.532 16.6666 17.108 16.6666 16.666V6.66602L11.6666 1.66602Z"
      stroke={STROKE_COLOR}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 1.66602V6.66602H16.6667"
      stroke={STROKE_COLOR}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99992 14.1673C10.9204 14.1673 11.6666 13.4211 11.6666 12.5007C11.6666 11.5802 10.9204 10.834 9.99992 10.834C9.07944 10.834 8.33325 11.5802 8.33325 12.5007C8.33325 13.4211 9.07944 14.1673 9.99992 14.1673Z"
      stroke={STROKE_COLOR}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 15.834C8.33333 14.1673 11.6667 14.1673 12.5 15.834"
      stroke={STROKE_COLOR}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const FullEmbedIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z"
      stroke={STROKE_COLOR}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 6.66602H17.5"
      stroke={STROKE_COLOR}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83325 10.834H14.1666"
      stroke={STROKE_COLOR}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83325 14.166H10.8333"
      stroke={STROKE_COLOR}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

interface Props {
  type: IntegrationType
}

const IntegrationTypeIcon = ({ type }: Props) => {
  const icon = (() => {
    switch (type) {
      case "api":
        return <CodeXml size={20} stroke={STROKE_COLOR} />
      case "boomtown":
        return <LoanOfficerEmbedIcon />
      case "widget":
        return <FullEmbedIcon />
      case "standalone":
        return <Blocks size={20} stroke={STROKE_COLOR} />
      case "chatbot":
        return <BotMessageSquare size={20} stroke={STROKE_COLOR} />
      case "button":
        return <MousePointerClick size={20} stroke={STROKE_COLOR} />
      case "standalone_pricing":
        return <DollarSign size={20} stroke={STROKE_COLOR} />
      default: {
        const _exhaustive: never = type
        throw new Error(`Unhandled IntegrationType: ${_exhaustive}`)
      }
    }
  })()

  return (
    <div className="size-12 bg-[#f6f1fe] rounded-md flex items-center justify-center shrink-0">
      {icon}
    </div>
  )
}

export default IntegrationTypeIcon
